export default "__VITE_PUBLIC_ASSET__28245d29__"